export default __webpack_public_path__ + "static/media/icon-direction-gauche.fb7d0d52.svg";